import React from "react";
import { NavLink } from "react-router-dom";
import { HOME_PATH, SIGNIN_PATH } from "../../constants/paths";

const SignedOutLinks = () => {
  return (
    <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
      <div className="text lg:flex-grow"></div>
      <div>
        <NavLink
          to={SIGNIN_PATH}
          activeClassName="active"
          exact
          className="inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-transparent hover:text-brand-700 hover:bg-white mt-4 lg:mt-0"
        >
          Iniciar sesión
        </NavLink>
      </div>
    </div>
  );
};

export default SignedOutLinks;
